import { isNil } from 'lodash';
import * as orderImageService from 'services/orderImageService';
import useSWR from 'swr';
import type { AxiosError } from 'axios';
import type { SWRResponse } from 'swr';

type SWRImagesData = Awaited<ReturnType<typeof orderImageService.getOrderImagesAsync>>;

const useOrderImages = (
  orderId: number,
  load = true
): SWRResponse<SWRImagesData, AxiosError> =>
  useSWR(
    !isNil(load) && load ? [SWR_ORDER_IMAGES_ENDPOINT, orderId] : null,
    async ([_, params]) => await orderImageService.getOrderImagesAsync(params)
  );

export const SWR_ORDER_IMAGES_ENDPOINT = 'orders-images';

export default useOrderImages;
